'use client';

import ListagemTitulos from '@/components/organisms/ListagemTitulos';
import BreadcrumbPagina from '@/components/molecules/BreadcrumbPagina';
import useRecomendadosPaginaHook from './hook/useRecomendadosPaginaHook';
import ListagemTitulosFallback from '@/components/organisms/ListagemTitulos/fallback';
import { Separator } from '@/components/atoms/Separator';
import ListagemConteudos from '@/components/organisms/ListagemConteudos';
import Heading from '@/components/atoms/Heading';

import * as S from './styles';
import Button from '@/components/atoms/Button';
import SearchField from '@/components/molecules/SearchField';
import { theme } from '@/styles/theme';
import ListagemConteudosFallback from '@/components/organisms/ListagemConteudos/fallback';
import useBreakpoint from '@/hooks/useBreakpoint';
import { UniversalScrollTracker } from '@/components/organisms/UniversalScrollTracker';
import DestaquesDaSemana from '@/components/organisms/DestaquesDaSemana';

export default function RecomendadosPagina() {
  const { breakpoint } = useBreakpoint();
  const {
    listasRecomendacoes,
    carregandoListasRecomendacoes,
    conteudos,
    carregarMais,
    busca,
    setBusca,
    carregandoConteudos,
    ultimaPagina,
    carregandoListasParceiros,
    listasParceiros,
  } = useRecomendadosPaginaHook();

  return (
    <S.Container>
      <UniversalScrollTracker pagina="recomendados" debug={false} />
      <BreadcrumbPagina $nomePaginaAtual="Recomendados" />
      <S.ContainerConteudo $breakpoint={breakpoint}>
        <DestaquesDaSemana
          mostrarBotoes={false}
          styleContainer={{
            padding: 0,
            gap: theme.spacing[8],
            backgroundColor: 'transparent',
          }}
          mostrarTitulo={false}
          tamanhoTituloListagens={6}
        />
        {carregandoListasParceiros
          ? Array.from({ length: 4 }).map((item, index) => (
              <ListagemTitulosFallback key={`${item}_${index}`} />
            ))
          : listasParceiros?.map((lista) => (
              <ListagemTitulos
                key={lista.categoriaID}
                $titulo={lista.nome}
                $conteudos={lista.conteudos}
                $carregandoConteudos={false}
                $ranking={lista.ranking}
                $paddingLeft={theme.spacing[6]}
              />
            ))}
        <S.ContainerListagemTitulos>
          <S.ContainerHeaderListagemTitulos $breakpoint={breakpoint}>
            <Heading
              $priority={2}
              $size={6}
              $color="neutral"
              $weight="bold"
              $align={'left'}
              $highContrast={true}
              $text="Favoritos dos fãs"
            />
            <SearchField
              $size={2}
              $variant="soft"
              $state={busca.length > 0 ? 'filled' : 'placeholder'}
              $label={false}
              $focusRing={false}
              $placeholder="Buscar por recomendação"
              onChange={(e) => setBusca(e?.target?.value)}
              style={{
                maxWidth: 240,
                width: '100%',
                backgroundColor: theme.colors.neutral.neutral_alpha[3],
                border: 'none',
              }}
              $inputProps={{
                value: busca,
              }}
              $iconeBuscaProps={{
                color: theme.colors.accent.accent[9],
              }}
            />
          </S.ContainerHeaderListagemTitulos>
          {!conteudos?.length && carregandoConteudos ? (
            <ListagemConteudosFallback />
          ) : (
            <ListagemConteudos $conteudos={conteudos} $busca={busca} />
          )}
          <div style={{ alignSelf: 'center' }}>
            {ultimaPagina ? null : (
              <Button
                style={{ justifyContent: 'center', minWidth: 155 }}
                $size={2}
                $variant="solid"
                $color="accent"
                $highContrast={false}
                $loading={carregandoConteudos}
                $focusRing={false}
                $text={'Mostrar mais'}
                $onClick={carregarMais}
              />
            )}
          </div>
        </S.ContainerListagemTitulos>
        <Separator $block={false} $orientation="horizontal" />
        {carregandoListasRecomendacoes
          ? Array.from({ length: 2 }).map((item, index) => (
              <ListagemTitulosFallback key={`${item}_${index}`} />
            ))
          : listasRecomendacoes?.map((lista) => (
              <ListagemTitulos
                key={lista.categoriaID}
                $titulo={lista.nome}
                $conteudos={lista.conteudos}
                $carregandoConteudos={false}
                $ranking={lista.ranking}
                $paddingLeft={theme.spacing[6]}
              />
            ))}
      </S.ContainerConteudo>
    </S.Container>
  );
}
